import { InjectionToken } from '@angular/core';

import { ServicesEnum } from 'sc-common/core/services/open-api/open-api-clients';

export interface BackgroundProcessConfig {
    allowedServicess: ServicesEnum[];
}

export const BACKGROUND_PROCESS_CONFIG = new InjectionToken<BackgroundProcessConfig>('BackgroundProcessConfig');